module.exports = __webpack_public_path__ + "img/Sorghum_bicolor.3e3cd6ca.jpg";